import {AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, OnDestroy, Output} from '@angular/core';

@Directive({
  selector: '[appOverflowMonitor]'
})
export class OverflowMonitorDirective implements AfterViewInit, OnDestroy {
  @Output() overflowChange = new EventEmitter<{
    overflowedIndex: number,
    sizeIncreased: boolean,
    isFirstTimeOverflow: boolean
  }>();
  @Output() sizeChange = new EventEmitter<boolean>();
  previousWidth: any;
  private resizeObserver: ResizeObserver;
  private isFirstTimeOverflow = true;


  constructor(private el: ElementRef) {
  }


  ngAfterViewInit() {
    const parentElement = this.el.nativeElement;
    this.previousWidth = parentElement.clientWidth;

    this.resizeObserver = new ResizeObserver(() => {
      let sizeIncreased = parentElement?.clientWidth > this.previousWidth;
      this.sizeChange.emit(sizeIncreased);
      this.checkOverflow();
    });

    this.resizeObserver.observe(this.el.nativeElement);
    this.checkOverflow();
  }

  // @HostListener('window:resize')
  checkOverflow() {
    const parentElement = this.el.nativeElement;
    const children = parentElement.children;
    const parentWidth = parentElement.clientWidth;
    let totalWidth = 0;
    let overflowedIndex = -1;
    let sizeIncreased = parentWidth > this.previousWidth;

    for (let i = 0; i < children.length; i++) {
      totalWidth += children[i].offsetWidth;
      if (totalWidth > parentWidth) {
        overflowedIndex = i;
        this.previousWidth = parentWidth;
        break;
      }
    }

    if (overflowedIndex !== -1) {
      this.overflowChange.emit({overflowedIndex, sizeIncreased, isFirstTimeOverflow: this.isFirstTimeOverflow});
      this.isFirstTimeOverflow = false;
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
